


































import Vue from "vue";
import Component from "vue-class-component";

@Component({
  name: "HomeMessage",
})
export default class HomeMessage extends Vue {}
